module.exports = __webpack_public_path__ + "static/media/ar21_sgordon.54506b28.jpeg";